'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroCheckbox = require('./NitroCheckbox');

var _NitroCheckbox2 = _interopRequireDefault(_NitroCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroCheckbox2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-checkbox/index.js
// module id = 132
// module chunks = 4